WW.scrollMagic = function($) {
    'use strict';


    let runScrollMagic = () => {
        let controller;
        controller = new ScrollMagic.Controller();


        // SITE HEADER
        const navbar = TweenMax.to('#site-nav', 1, {
            height: 55,
            lineHeight: 55 + 'px'
        });
        new ScrollMagic.Scene({
            duration: 500
        })
        .setTween(navbar)
        .addTo(controller);


        const navbarBackground = TweenMax.to('#site-nav-background', 1, {
            opacity: 0.95
        });
        new ScrollMagic.Scene({
            duration: 500
        })
        .setTween(navbarBackground)
        .addTo(controller);


        // const navbarLogoAdditional = TweenMax.to('#navbar-logo-additional', 1, {
        //     x: -50,
        // });
        // new ScrollMagic.Scene({
        //     duration: 500
        // })
        // .setTween(navbarLogoAdditional)
        // .addTo(controller);


        // navbar-logo-additional


        // SITE BANNER BANNER CONTENT
        const frontpageBannerContent = TweenMax.to('#banner-content', 1, {
            y: 450,
            scale: 0.8,
            opacity: 0
        });
        new ScrollMagic.Scene({
            duration: 1200,
            offset: 50
        })
        .setTween(frontpageBannerContent)
        .addTo(controller);


        // VISUAL CUE CONTACT BUTTON
        const $frontpageBanner = $('.c-banner--lg .c-banner__overlay'),
            $visualCue = $('#visual-cue-contact');

        if ($visualCue.length && $frontpageBanner.length) {
            new ScrollMagic.Scene({
                offset: $frontpageBanner.height() + $frontpageBanner.offset().top - $visualCue.offset().top - $visualCue.width()
            })
            .setClassToggle('#visual-cue-contact', 'c-btn--sticky--is-hidden')
            .addTo(controller);
        }
    };

    const runInMediaQuery = () => {
        const mQuery = WW.checkCurrentMediaQuery;
        return mQuery.screenMd || mQuery.screenLg || mQuery.screenXl;
    };

    !WW.isTouch && runInMediaQuery() && runScrollMagic();

    return this;
};
